/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import API from "../../utils/API";
import Html from "../../utils/Html";
import TopContent from "./top.content";
import MainContent from "./main.content";
import Func from "../../utils/Func";
import "./style.css";

const Team = (props) => {
  let userData = window.$user_profile;
  const [filterData, setFilterData] = useState({
    data: "",
    err: 0,
    err_msg: "" });

  // 1) ให้ defaultFilters เป็น state
  const [defaultFilters, setDefaultFilters] = useState(() => ({
    country: [
      userData.is_exo_group == "yes" ? "GROUP" : userData.employed_by_code,
    ],
    department: [],
    division: [],
    start_date: [Func.GetStartDate()],
    end_date: [Func.GetEndDate(Func.GetStartDate())],
    key_form: 0,
    limit: 10,
    page: 1 }));

  // filters ใช้ค่าเริ่มจาก defaultFilters
  const [filters, setFilters] = useState(defaultFilters);

  // ... useEffect เดิมของคุณ
  useEffect(() => {
    const mainFunc = async () =>
      await API.post("team/filter", {
        params: ({
          country_name: userData.employed_by,
          country_code: userData.employed_by_code,
          is_access_all_country: userData.user_sess.userCanAccessAllCountries,
          is_exo_group: userData.is_exo_group,
          user_id: userData.idu,
          user_country_access_code:
            userData?.user_countries_access?.codes ?? [],
          user_dept: userData?.user_only_dept ?? [],
          user_divs: userData?.user_only_divs ?? [] }) });

    mainFunc()
      .then((res) => {
        const decrypt = (res?.data);
        if (decrypt?.status === "success") {
          try {
            // คำนวณ defaults ใหม่จากข้อมูลที่โหลดมา
            let userDept = [];
            // userDept = Func.getDeptIdsByCountryAndUser(
            //   decrypt.data.departments ?? [],
            //   filters.country,
            //   userData.user_only_dept ?? []
            // );
            let userDivs = [];
            // if (userDept.length > 0) {
            //   userDivs = Func.getValuesByParent(
            //     decrypt.data?.divisions ?? [],
            //     userDept,
            //     userData.user_only_divs ?? []
            //   );
            // }
            // console.log("***** userDept=", userDept);
            // console.log("***** newUserDept=", newUserDept);
            // console.log("***** userDivs=", userDivs);
            // console.log("***** division=", division);
            const newDefaults = {
              country: [
                userData.is_exo_group == "yes"
                  ? "GROUP"
                  : userData.employed_by_code,
              ],
              department: Func.toNumberArray(userDept),
              division: userDivs,
              start_date: [Func.GetStartDate()],
              end_date: [Func.GetEndDate(Func.GetStartDate())],
              key_form: Func.GetKeyRandom(),
              limit: 10,
              page: 1 };

            // 2) อัปเดตทั้ง defaultFilters และ filters ให้ตรงกัน
            setDefaultFilters(newDefaults);
            setFilters(newDefaults);

            setFilterData(decrypt); // เดิม
          } catch (e) {
            // ถ้าคิดค่าไม่สำเร็จ เก็บ filters เดิมไว้
            setFilterData(decrypt);
          }
        } else {
          setFilterData({
            err: 1,
            err_msg: `Failes : ${decrypt?.err_msg ?? ""}` });
        }
      })
      .catch((err) => {
        setFilterData({ err: 1, err_msg: `Failes : ${err}` });
      });
  }, []); // รันครั้งเดียวเมื่อ mount

  if (
    !("user_sess" in userData) ||
    !userData["user_sess"].userCanAccessTeamView
  ) {
    return <Html.NoAccess />;
  }
  if (filterData.err == 1) {
    return <div>Fetch request error: {filterData.err_msg}</div>;
  } else if (filterData.data == "") {
    return (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto" } }}
        />
      </div>
    );
  }

  return (
    <div id="team-content">
      <TopContent
        userData={userData}
        filterData={filterData.data}
        filters={filters}
        setFilters={setFilters}
      />
      <MainContent
        userData={userData}
        filterData={filterData.data}
        filters={filters}
        setFilters={setFilters}
        defaultFilters={defaultFilters}
      />
    </div>
  );
};
export default Team;


